import {
  SET_STEP,
  ADD_PAGE_VISITED,
  ADD_PAGE_SUBMITTED,
  REMOVE_SUBMITTED_PAGE,
  CLEAR_STEPS,
} from './constants';

export const setStep = payload => {
  return {
    type: SET_STEP,
    payload,
  };
};

export const addPageVisited = pageName => {
  return {
    type: ADD_PAGE_VISITED,
    payload: pageName,
  };
};

export const addPageSubmitted = pageName => {
  return {
    type: ADD_PAGE_SUBMITTED,
    payload: pageName,
  };
};

export const removeSubmittedPage = pageName => {
  return {
    type: REMOVE_SUBMITTED_PAGE,
    payload: pageName,
  };
};

export const clearStepTracker = () => {
  return {
    type: CLEAR_STEPS,
  };
};
